// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3gFiX","Success":"Button_Success__2Rka1","Toggle":"Button_Toggle__34463","Danger":"Button_Danger__2ogZq"};